module.exports = __webpack_public_path__ + "static/media/amex.fa9cc1e8.svg";